module.exports = " <li class=nav-item _v-68cf3e5e=\"\"> <a class=nav-link _v-68cf3e5e=\"\"><span class=icon-user-tie _v-68cf3e5e=\"\"></span><span class=Logout__name _v-68cf3e5e=\"\">{{ user.username }}</span></a> </li> <li class=nav-item _v-68cf3e5e=\"\"> <a class=nav-link href=# @click.prevent=logout _v-68cf3e5e=\"\">Déconnexion</a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-68cf3e5e!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Logout.vue
// module id = 530
// module chunks = 1